import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import reducers from 'src/reducers'
import { saveState } from 'src/utils'

const composeEnhancers =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)))

store.subscribe(() => saveState(store, ['userToken']))

typeof window !== 'undefined' &&
  Object.defineProperty(window, 'state', {
    get: () => store.getState(),
  })

export const dispatch = store.dispatch

export const getState = store.getState

export default store
